export const TIME_PER_STEP = 12000;
